import React from 'react';
import { components } from '@peachjar/components';

const {
  Buttons: { ButtonPrimaryLarge },
} = components;

const StartUsing = ({ continueToAccount, isButtonEnabled }) => (
  <ButtonPrimaryLarge
    disabled={!isButtonEnabled}
    onClick={continueToAccount}
    data-testid="continueOnTraining"
  >
    Start Exploring
  </ButtonPrimaryLarge>
);

export default StartUsing;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff-training/components/StartUsing.jsx